import React from 'react';
import { useNavigate } from 'react-router-dom';
import HostLayout from '../layouts/HostLayout';
import Logo from '../components/Logo';

const UpcomingShows = () => {
  const navigate = useNavigate();

  return (
    <HostLayout>
      <div className="min-h-screen bg-gray-900 p-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8">
            <Logo className="h-16 mx-auto mb-4" />
            <h1 className="text-3xl font-bold text-white mb-2">Upcoming Shows</h1>
            <p className="text-gray-400">Manage your calendar and availability</p>
          </div>

          <div className="bg-gray-800 rounded-lg p-8">
            <div className="text-center">
              <div className="text-6xl mb-4">📅</div>
              <h2 className="text-2xl font-bold text-white mb-4">Coming Soon!</h2>
              <p className="text-gray-400 mb-6">
                The calendar and show management system is currently under development.
                <br />
                You'll be able to schedule shows, manage availability, and coordinate with venues.
              </p>
              <button
                onClick={() => navigate('/home')}
                className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
              >
                Back to Dashboard
              </button>
            </div>
          </div>
        </div>
      </div>
    </HostLayout>
  );
};

export default UpcomingShows; 